import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { salesForceIntegrationDataSource } from 'infrastructure/data-sources/salesforce-integration';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ISalesForceIntegration } from 'infrastructure/data-sources/salesforce-integration';

type Options = IBaseSelectBoxOption<
  ISalesForceIntegration['id'],
  ISalesForceIntegration
>[];

interface ISalesForceIntegrationSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const SalesForceIntegrationSelectBox: React.FC<
  ISalesForceIntegrationSelectBoxProps
> = (props) => {
  const dataSource = useMemo(() => salesForceIntegrationDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default SalesForceIntegrationSelectBox;
